import { useTheme } from '@material-ui/core/styles';
import PropTypes from 'prop-types';
import React from 'react';

export default function Menu({ fill, ...props }) {
  const theme = useTheme();

  return (
    <svg
      width="36"
      height="36"
      viewBox="0 0 36 36"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M0 4C0 1.79086 1.79086 0 4 0H32C34.2091 0 36 1.79086 36 4V32C36 34.2091 34.2091 36 32 36H4C1.79086 36 0 34.2091 0 32V4Z"
        fill={theme.palette.text.primary}
        fillOpacity="0.8"
      />
      <rect x="8" y="9" width="20" height="3" rx="1.5" fill={fill} />
      <rect x="8" y="16" width="20" height="3" rx="1.5" fill={fill} />
      <rect x="8" y="23" width="20" height="3" rx="1.5" fill={fill} />
    </svg>
  );
}

Menu.propTypes = {
  fill: PropTypes.string
};

Menu.defaultProps = {
  fill: '#02BBD3'
};
